import e, { createContext as t, useCallback as n, useContext as r, useEffect as i, useMemo as a, useRef as o, useState as s } from "react";
//#region src/core/form.ts
var c = "source";
function l(e, t = c) {
	let n = e.split(".").filter(Boolean);
	return n[0] === t ? n.slice(1) : n;
}
function u(e, t, n = c) {
	return l(t, n).reduce((e, t) => {
		if (typeof e == "object" && e) return e[t];
	}, e);
}
function d(e, t, n, r = c) {
	let i = l(t, r);
	if (i.length === 0) return e;
	let a = { ...e }, o = a;
	return i.forEach((e, t) => {
		if (t === i.length - 1) {
			n === void 0 || n === "" ? delete o[e] : o[e] = n;
			return;
		}
		let r = o[e];
		o[e] = { ...r && typeof r == "object" && !Array.isArray(r) ? r : {} }, o = o[e];
	}), a;
}
function f(e, t) {
	if (t !== "") {
		if (e.data_type === "number") {
			if (typeof t == "number") return t;
			let e = Number(t);
			return Number.isNaN(e) ? t : e;
		}
		if (e.data_type === "boolean") {
			if (typeof t == "boolean") return t;
			if (t === "true") return !0;
			if (t === "false") return !1;
		}
		return t;
	}
}
function p(e, t, n = c) {
	return t.reduce((e, t) => t.behavior === "display" || t.behavior === "fixed" || t.default === void 0 || !h(u(e, t.path, n)) ? e : d(e, t.path, t.default, n), e);
}
function m(e, t, n = c) {
	let r = t.reduce((t, r) => {
		if (r.behavior === "display") return t;
		if (r.behavior === "fixed") return r.const === void 0 ? t : d(t, r.path, r.const, n);
		let i = u(e, r.path, n);
		return i === void 0 ? t : d(t, r.path, i, n);
	}, {});
	return t.reduce((e, t) => {
		if (t.data_type !== "json") return e;
		let r = u(e, t.path, n);
		if (typeof r != "string" || r.trim() === "") return e;
		try {
			return d(e, t.path, JSON.parse(r), n);
		} catch {
			return e;
		}
	}, r);
}
function h(e) {
	return e == null || e === "";
}
//#endregion
//#region src/core/types/dataset.ts
var g = [
	10,
	15,
	60,
	360,
	720,
	1440
], _ = "2023-12-01", v = "unknown_error", y = 0;
async function b(e, t) {
	return {
		"Content-Type": "application/json",
		"X-Prequel-Api-Version": _,
		...await e.headers?.(t)
	};
}
function x(e) {
	return typeof e == "object" && !!e && "code" in e && typeof e.code == "string" && "message" in e && typeof e.message == "string" && "statusCode" in e && typeof e.statusCode == "number";
}
function S(e) {
	return x(e) ? e : typeof e == "object" && e && "message" in e && typeof e.message == "string" && "statusCode" in e && typeof e.statusCode == "number" ? {
		code: `http_${e.statusCode}`,
		message: e.message,
		statusCode: e.statusCode
	} : e instanceof Error ? {
		code: v,
		message: e.message,
		statusCode: 0
	} : typeof e == "string" ? {
		code: v,
		message: e,
		statusCode: 0
	} : {
		code: v,
		message: "An unknown error occurred.",
		statusCode: 0
	};
}
async function C(e, t) {
	let n = `http_${e.status}`, r = t;
	try {
		let t = await e.json();
		n = t.code ?? t.error_code ?? n, t.message && (r = t.message);
	} catch {}
	return {
		code: n,
		message: r,
		statusCode: e.status
	};
}
async function w(e, t, n, r, i) {
	let a = `${e.baseUrl}${n}`, o = r == null ? void 0 : JSON.stringify(r), s = async () => fetch(a, {
		method: t,
		headers: await b(e, i),
		body: o,
		credentials: e.credentials
	}), c = await s();
	if (c.status === 401 && e.onUnauthorized && (await e.onUnauthorized(i), c = await s()), !c.ok) throw await C(c, `Request failed: ${t} ${n}`);
	if (t !== "DELETE") return (await c.json()).data;
}
async function T(e, t, n, r, i) {
	let a = new URL(`${e.baseUrl}${t}`);
	if (r) for (let [e, t] of Object.entries(r)) t !== void 0 && a.searchParams.set(e, t);
	n?.cursor && a.searchParams.set("cursor", n.cursor), n?.page_size && a.searchParams.set("page_size", String(n.page_size));
	let o = async () => fetch(a.toString(), {
		method: "GET",
		headers: await b(e, i),
		credentials: e.credentials
	}), s = await o();
	if (s.status === 401 && e.onUnauthorized && (await e.onUnauthorized(i), s = await o()), !s.ok) throw await C(s, `Request failed: GET ${t}`);
	let c = await s.json();
	return {
		data: c.data,
		has_next: c.has_next,
		next_url: c.next_url
	};
}
function E(e) {
	return {
		get: (t, n) => w(e, "GET", t, void 0, n),
		getPaginated: (t, n, r, i) => T(e, t, n, r, i),
		post: (t, n, r) => w(e, "POST", t, n, r),
		patch: (t, n, r) => w(e, "PATCH", t, n, r),
		delete: (t, n) => w(e, "DELETE", t, void 0, n)
	};
}
//#endregion
//#region src/core/api/routes.ts
var D = "/import/datasets", O = "/import/destinations", k = "/import/extracts", A = "/import/streams", j = "/import/loads", M = "/import/sources", N = {
	datasets: {
		list: D,
		get: (e) => `${D}/${e}`,
		schema: (e) => `${D}/${e}/schema`,
		randomSample: (e) => `${D}/${e}/random-sample`,
		create: D,
		update: (e) => `${D}/${e}`
	},
	destinations: {
		list: O,
		get: (e) => `${O}/${e}`
	},
	extracts: {
		list: k,
		get: (e) => `${k}/${e}`,
		debug: (e) => `${k}/${e}/debug`
	},
	streams: {
		list: A,
		get: (e) => `${A}/${e}`,
		create: A,
		update: (e) => `${A}/${e}`,
		testNew: "/import/test-stream",
		testExisting: (e) => `${A}/${e}/test-transform`,
		testExpression: "/import/actions/test-expr"
	},
	loads: {
		list: j,
		get: (e) => `${j}/${e}`,
		debug: (e) => `${j}/${e}/debug`
	},
	sources: {
		list: M,
		get: (e) => `${M}/${e}`,
		listTables: (e) => `${M}/${e}/get-tables`,
		getSchema: (e) => `${M}/${e}/get-schema`,
		preview: (e) => `${M}/${e}/preview`,
		create: M,
		update: (e) => `${M}/${e}`,
		delete: (e) => `${M}/${e}`,
		form: "/import/forms/sources",
		generateKey: (e) => `/import/actions/generate-key?provider_id=${encodeURIComponent(e)}`,
		testNew: "/import/test-source",
		testExisting: (e) => `${M}/${e}/test-source`
	}
};
function P(e, t = {}) {
	return {
		datasets: {
			...e.datasets,
			...t.datasets
		},
		destinations: {
			...e.destinations,
			...t.destinations
		},
		extracts: {
			...e.extracts,
			...t.extracts
		},
		streams: {
			...e.streams,
			...t.streams
		},
		loads: {
			...e.loads,
			...t.loads
		},
		sources: {
			...e.sources,
			...t.sources
		}
	};
}
function ee(e = {}) {
	return P(N, e);
}
function F(e) {
	if (!e) throw Error("providerId is required to create provider-scoped Import API routes.");
	let t = `/import/providers/${encodeURIComponent(e)}`, n = `${t}/datasets`, r = `${t}/destinations`, i = `${t}/extracts`, a = `${t}/streams`, o = `${t}/loads`, s = `${t}/sources`;
	return {
		datasets: {
			list: n,
			get: (e) => `${n}/${e}`,
			schema: (e) => `${n}/${e}/schema`,
			randomSample: (e) => `${n}/${e}/random-sample`,
			create: n,
			update: (e) => `${n}/${e}`
		},
		destinations: {
			list: r,
			get: (e) => `${r}/${e}`
		},
		extracts: {
			list: i,
			get: (e) => `${i}/${e}`,
			debug: (e) => `${i}/${e}/debug`
		},
		streams: {
			list: a,
			get: (e) => `${a}/${e}`,
			create: a,
			update: (e) => `${a}/${e}`,
			testNew: `${t}/test-stream`,
			testExisting: (e) => `${a}/${e}/test-transform`,
			testExpression: N.streams.testExpression
		},
		loads: {
			list: o,
			get: (e) => `${o}/${e}`,
			debug: (e) => `${o}/${e}/debug`
		},
		sources: {
			list: s,
			get: (e) => `${s}/${e}`,
			listTables: (e) => `${s}/${e}/get-tables`,
			getSchema: (e) => `${s}/${e}/get-schema`,
			preview: (e) => `${s}/${e}/preview`,
			create: s,
			update: (e) => `${s}/${e}`,
			delete: (e) => `${s}/${e}`,
			form: N.sources.form,
			generateKey: () => `${t}/actions/generate-key`,
			testNew: `${t}/test-source`,
			testExisting: (e) => `${s}/${e}/test-source`
		}
	};
}
function te(e, t) {
	return P(e.routes ?? N, t);
}
//#endregion
//#region src/core/api/datasets.ts
function I(e, t = N.datasets) {
	return {
		list: (n) => e.getPaginated(t.list, n, {
			datalake_id: n?.datalake_id,
			source_id: n?.source_id,
			type: n?.type
		}).then((e) => ({
			data: e.data.datasets,
			has_next: e.has_next,
			next_url: e.next_url
		})),
		get: (n) => e.get(t.get(n)).then((e) => e.dataset),
		schema: (n) => e.get(t.schema(n)).then((e) => e.columns),
		randomSample: (n, r) => e.post(t.randomSample(n), { sample_size: r }),
		create: (n) => e.post(t.create, { dataset: n }).then((e) => e.dataset),
		update: (n, r) => e.patch(t.update(n), { dataset: r }).then((e) => e.dataset)
	};
}
//#endregion
//#region src/core/api/destinations.ts
function L(e, t = N.destinations) {
	return {
		list: (n) => e.getPaginated(t.list, n).then((e) => ({
			data: e.data.destinations,
			has_next: e.has_next,
			next_url: e.next_url
		})),
		get: (n) => e.get(t.get(n)).then((e) => e.destination)
	};
}
//#endregion
//#region src/core/api/extracts.ts
function R(e, t = N.extracts) {
	return {
		list: (n, r) => e.getPaginated(t.list, r, { dataset_id: n }).then((e) => ({
			data: e.data.extracts,
			has_next: e.has_next,
			next_url: e.next_url
		})),
		get: (n) => e.get(t.get(n)).then((e) => e.extract),
		debug: (n, r, i) => e.getPaginated(t.debug(n), r, i).then((e) => ({
			data: e.data.records,
			has_next: e.has_next,
			next_url: e.next_url
		}))
	};
}
//#endregion
//#region src/core/api/loads.ts
function z(e, t = N.loads) {
	return {
		list: (n, r) => e.getPaginated(t.list, r, { stream_id: n }).then((e) => ({
			data: e.data.loads,
			has_next: e.has_next,
			next_url: e.next_url
		})),
		get: (n) => e.get(t.get(n)).then((e) => e.load),
		debug: (n, r, i) => e.getPaginated(t.debug(n), r, i).then((e) => ({
			data: e.data.records,
			has_next: e.has_next,
			next_url: e.next_url
		}))
	};
}
//#endregion
//#region src/core/api/sources.ts
function B(e) {
	return e.code ? {
		status: "error",
		code: e.code,
		message: e.message || "Source connection test failed."
	} : {
		status: "success",
		message: e.message
	};
}
function V(e, t = N.sources) {
	return {
		list: (n) => e.getPaginated(t.list, n, { provider_id: n?.provider_id }).then((e) => ({
			data: e.data.sources,
			has_next: e.has_next,
			next_url: e.next_url
		})),
		get: (n) => e.get(t.get(n)).then((e) => e.source),
		listTables: (n) => e.post(t.listTables(n)).then((e) => e.tables),
		getSchema: (n, r) => e.post(t.getSchema(n), r).then((e) => e.schema),
		preview: (n, r) => e.post(t.preview(n), r),
		create: (n) => e.post(t.create, { source: n }, { auth: { source: n } }).then((e) => e.source),
		update: (n, r) => e.patch(t.update(n), { source: r }).then((e) => e.source),
		delete: (n) => e.delete(t.delete(n)),
		createForm: (n, r = "create") => e.post(r === "edit" ? `${t.form}?mode=edit` : t.form, { source: n }),
		generateKey: (n) => e.post(t.generateKey(n)),
		testNew: (n) => e.post(t.testNew, { source: n }, { auth: { source: n } }).then(B),
		testExisting: (n, r) => e.post(t.testExisting(n), r ? { source: r } : void 0).then(B)
	};
}
//#endregion
//#region src/core/api/streams.ts
function H(e, t = N.streams) {
	return {
		list: (n) => e.getPaginated(t.list, n, {
			dataset_id: n?.dataset_id,
			destination_id: n?.destination_id
		}).then((e) => ({
			data: e.data.streams,
			has_next: e.has_next,
			next_url: e.next_url
		})),
		get: (n) => e.get(t.get(n)).then((e) => e.stream),
		create: (n) => e.post(t.create, { stream: n }).then((e) => e.stream),
		update: (n, r) => e.patch(t.update(n), { stream: r }).then((e) => e.stream),
		testNew: (n) => e.post(t.testNew, n),
		testExisting: (n, r) => e.post(t.testExisting(n), r),
		testExpression: (n) => e.post(t.testExpression, n)
	};
}
//#endregion
//#region src/core/defaults.ts
var ne = "https://api.prequel.co", re = "third-party-client";
function ie(e) {
	if (e.trim() === "") throw Error("providerId is required to create a default Import API client.");
}
function ae(e) {
	ie(e.providerId);
	let t, n, r = async () => t || (n ??= e.fetchToken({ providerId: e.providerId }).then((e) => (t = e, n = void 0, e)).catch((e) => {
		throw n = void 0, e;
	}), n), i = async (t) => {
		let n = t?.auth?.source;
		return n ? e.fetchToken({
			providerId: e.providerId,
			source: n
		}) : r();
	}, a = () => {
		t = void 0, n = void 0;
	};
	return {
		...E({
			...e,
			baseUrl: e.baseUrl ?? "https://api.prequel.co",
			headers: async (t) => ({
				...await e.headers?.(t),
				"X-APP-ID": e.appId ?? "third-party-client",
				Authorization: `Bearer ${await i(t)}`
			}),
			onUnauthorized: (e) => {
				e?.auth?.source || a();
			}
		}),
		routes: F(e.providerId)
	};
}
//#endregion
//#region src/react/context.ts
var U = t(null);
function W() {
	let e = r(U);
	if (!e) throw Error("useImportContext must be used within an ImportProvider");
	return e;
}
//#endregion
//#region src/react/ImportProvider.tsx
function oe(e, t) {
	let n = te(e, t);
	return {
		datasets: I(e, n.datasets),
		destinations: L(e, n.destinations),
		extracts: R(e, n.extracts),
		streams: H(e, n.streams),
		loads: z(e, n.loads),
		sources: V(e, n.sources)
	};
}
function se({ client: t, routes: n, children: r }) {
	let i = a(() => oe(t, n), [t, n]);
	return e.createElement(U.Provider, { value: i }, r);
}
//#endregion
//#region src/react/useAction.ts
function G() {
	return {
		data: void 0,
		pending: !1,
		status: "idle",
		error: null
	};
}
function K(e) {
	let [t, r] = s(() => G()), i = n(() => {
		r(G());
	}, []), a = n(async (...t) => {
		r({
			data: void 0,
			pending: !0,
			status: "pending",
			error: null
		});
		try {
			let n = await e(...t);
			return r({
				data: n,
				pending: !1,
				status: "success",
				error: null
			}), {
				ok: !0,
				data: n,
				error: null
			};
		} catch (e) {
			let t = S(e);
			return r({
				data: void 0,
				pending: !1,
				status: "error",
				error: t
			}), {
				ok: !1,
				data: void 0,
				error: t
			};
		}
	}, [e]);
	return {
		execute: a,
		run: n(async (...e) => {
			let t = await a(...e);
			if (!t.ok) throw t.error;
			return t.data;
		}, [a]),
		reset: i,
		...t
	};
}
//#endregion
//#region src/react/useQuery.ts
function q(e) {
	let [t, r] = s(), [a, o] = s(!0), [c, l] = s(void 0), [u, d] = s(0), f = n(() => d((e) => e + 1), []);
	return i(() => {
		let t = !1;
		return o(!0), r(void 0), l(void 0), e().then((e) => {
			t || r(e);
		}).catch((e) => {
			t || (r(void 0), l(e));
		}).finally(() => {
			t || o(!1);
		}), () => {
			t = !0;
		};
	}, [e, u]), {
		data: t,
		isLoading: a,
		error: c,
		refetch: f
	};
}
//#endregion
//#region src/react/usePaginatedQuery.ts
var ce = [], le = (e, t, n) => JSON.stringify({
	args: e ?? null,
	pageSize: t,
	cursor: n
});
function J(e, t, r = {}) {
	let { cursor: i, pageSize: a } = r, c = le(t, a, i), l = () => ({
		cursor: i,
		args: t,
		key: c
	}), [u, d] = s(l), f = u;
	u.key !== c && (f = l(), d(f));
	let p = o(e);
	p.current = e;
	let { cursor: m, args: h } = f, g = q(n(() => p.current({
		cursor: m,
		page_size: a
	}, h), [
		m,
		a,
		h
	])), _ = g.data?.next_url, v = _ ? new URL(_, "https://prequel.local").searchParams.get("cursor") ?? void 0 : void 0, y = n((e) => {
		d((t) => ({
			...t,
			cursor: e
		}));
	}, []), b = n(() => {
		v && y(v);
	}, [y, v]);
	return {
		data: g.data?.data,
		isLoading: g.isLoading,
		error: g.error,
		refetch: g.refetch,
		items: g.data?.data ?? ce,
		nextCursor: v,
		hasNextPage: g.data?.has_next === !0 && !!v,
		fetchNextPage: b,
		fetchPage: y
	};
}
//#endregion
//#region src/react/datasets.ts
function ue(e) {
	let { datasets: t } = W();
	return J((e, n) => t.list({
		...e,
		datalake_id: n.datalakeId,
		source_id: n.sourceId,
		type: n.type
	}), {
		datalakeId: e?.datalakeId,
		sourceId: e?.sourceId,
		type: e?.type
	}, e);
}
function de(e) {
	let { datasets: t } = W();
	return q(n(() => t.get(e), [t, e]));
}
function fe(e) {
	let { datasets: t } = W(), r = q(n(() => e ? t.schema(e) : Promise.resolve(void 0), [t, e]));
	return {
		...r,
		schema: r.data,
		refresh: r.refetch
	};
}
function pe() {
	let { datasets: e } = W(), t = K(n(({ datasetId: t, sampleSize: n }) => e.randomSample(t, n), [e]));
	return {
		...t,
		randomSampleDataset: t.run,
		sample: t.data,
		isSampling: t.pending
	};
}
function me() {
	let { datasets: e } = W(), t = K(n((t) => e.create(t), [e]));
	return {
		...t,
		createDataset: t.run,
		dataset: t.data,
		isCreating: t.pending
	};
}
function he() {
	let { datasets: e } = W(), t = K(n((t, n) => e.update(t, n), [e]));
	return {
		...t,
		updateDataset: t.run,
		dataset: t.data,
		isUpdating: t.pending
	};
}
//#endregion
//#region src/react/destinations.ts
function ge(e) {
	let { destinations: t } = W();
	return J((e) => t.list(e), void 0, e);
}
function _e(e) {
	let { destinations: t } = W();
	return q(n(() => e ? t.get(e) : Promise.resolve(void 0), [t, e]));
}
//#endregion
//#region src/react/extracts.ts
function ve(e, t) {
	let { extracts: n } = W();
	return J((e, t) => n.list(t.datasetId, e), { datasetId: e }, t);
}
function ye(e, t, n) {
	let { extracts: r } = W();
	return J((e, t) => r.debug(t.extractId, e, t.filters), {
		extractId: e,
		filters: n
	}, t);
}
function be(e) {
	let { extracts: t } = W();
	return q(n(() => t.get(e), [t, e]));
}
//#endregion
//#region src/react/loads.ts
function xe(e, t) {
	let { loads: n } = W();
	return J((e, t) => n.list(t.streamId, e), { streamId: e }, t);
}
function Se(e) {
	let { loads: t } = W();
	return q(n(() => t.get(e), [t, e]));
}
function Ce(e, t, n) {
	let { loads: r } = W();
	return J((e, t) => r.debug(t.loadId, e, t.filters), {
		loadId: e,
		filters: n
	}, t);
}
//#endregion
//#region src/react/sources.ts
function Y(e) {
	return `${e.length}:${e}`;
}
function we(e) {
	if (e !== void 0) switch (e.method) {
		case "table": return [
			e.method,
			Y(e.table.source_table_namespace),
			Y(e.table.source_table_name)
		].join(":");
		case "sql": return [e.method, Y(e.sql.query)].join(":");
		case "glob": return [
			e.method,
			Y(e.glob.pattern),
			e.glob.format
		].join(":");
	}
}
function Te(e) {
	let { sources: t } = W();
	return J((e, n) => t.list({
		...e,
		provider_id: n.providerId
	}), { providerId: e?.providerId }, e);
}
function Ee(e) {
	let { sources: t } = W();
	return q(n(() => t.get(e), [t, e]));
}
function De(e) {
	let { sources: t } = W(), r = q(n(() => e ? t.listTables(e) : Promise.resolve(void 0), [t, e]));
	return {
		...r,
		tables: r.data,
		refresh: r.refetch
	};
}
function Oe(e, t) {
	let { sources: r } = W(), i = o(t);
	i.current = t;
	let a = we(t), s = q(n(() => !e || i.current === void 0 ? Promise.resolve(void 0) : r.getSchema(e, i.current), [
		r,
		e,
		a
	]));
	return {
		...s,
		schema: s.data,
		refresh: s.refetch
	};
}
function ke() {
	let { sources: e } = W(), t = K(n((t, n) => e.preview(t, n), [e]));
	return {
		...t,
		previewSourceRows: t.run,
		preview: t.data,
		isPreviewing: t.pending
	};
}
function Ae() {
	let { sources: e } = W(), t = K(n((t) => e.create(t), [e]));
	return {
		...t,
		createSource: t.run,
		source: t.data,
		isCreating: t.pending
	};
}
function je() {
	let { sources: e } = W(), t = K(n((t, n) => e.update(t, n), [e]));
	return {
		...t,
		updateSource: t.run,
		source: t.data,
		isUpdating: t.pending
	};
}
function Me() {
	let { sources: e } = W(), t = K(n((t) => e.testNew(t), [e]));
	return {
		...t,
		testNewSource: t.run,
		result: t.data,
		isTesting: t.pending
	};
}
function Ne() {
	let { sources: e } = W(), t = K(n((t, n) => e.testExisting(t, n), [e]));
	return {
		...t,
		testExistingSource: t.run,
		result: t.data,
		isTesting: t.pending
	};
}
//#endregion
//#region src/react/useDynamicForm.ts
var Pe = {};
function X({ fetchForm: e, rootKey: t = c, identity: r, hiddenFieldPaths: l, initialValues: u = Pe, enabled: m = !0 }) {
	let [h, g] = s(u), [_, v] = s([]), [y, b] = s(m), [x, S] = s(!1), [C, w] = s(void 0), T = o(0), E = a(() => new Set(l ?? []), [l]), D = n(async (n, i) => {
		let a = T.current + 1;
		T.current = a, i === "initial" ? b(!0) : S(!0), w(void 0);
		try {
			let i = await e({
				...n,
				...r
			});
			if (a !== T.current) return;
			let o = i.fields.filter((e) => !E.has(e.path));
			v(o);
			let s = p(n, o, t);
			g(s);
		} catch (e) {
			a === T.current && w(e);
		} finally {
			a === T.current && (b(!1), S(!1));
		}
	}, [
		e,
		E,
		r,
		t
	]);
	return i(() => {
		let e = u;
		if (g(e), v([]), !m) {
			T.current += 1, b(!1), S(!1), w(void 0);
			return;
		}
		D(e, "initial");
	}, [
		m,
		D,
		u
	]), {
		values: h,
		fields: _,
		setFieldValue: n((e, n) => {
			let r = typeof e == "string" ? _.find((t) => t.path === e) : e, i = typeof e == "string" ? e : e.path, a = r ? f(r, n) : n, o = d(h, i, a, t);
			g(o), r?.refetch_on_change && D(o, "refetch");
		}, [
			D,
			_,
			t,
			h
		]),
		isLoading: y,
		isRefetching: x,
		error: C
	};
}
//#endregion
//#region src/react/sourceForm.ts
var Fe = [
	"source.provider_id",
	"source.vendor",
	"source.name"
], Z = "source";
function Q({ providerId: e, vendor: t, initialSource: r, enabled: i = !0, mode: o = "create" }) {
	let { sources: s } = W(), c = a(() => ({
		provider_id: e,
		vendor: t
	}), [e, t]), { values: l, fields: u, setFieldValue: d, isLoading: f, isRefetching: p, error: h } = X({
		fetchForm: n((e) => s.createForm(e, o), [s, o]),
		rootKey: Z,
		identity: c,
		hiddenFieldPaths: Fe,
		initialValues: r,
		enabled: i && e !== "" && t !== ""
	}), g = l;
	return {
		source: g,
		draft: g,
		fields: u,
		setSourceField: d,
		getSource: n((e = {}) => ({
			...m(l, u, Z),
			...e,
			...c
		}), [
			u,
			c,
			l
		]),
		getUpdate: n((e = {}) => ({
			...m(l, u, Z),
			...e
		}), [u, l]),
		isLoading: f,
		isRefetching: p,
		error: h
	};
}
function Ie(e) {
	return Q(e);
}
function Le(e) {
	return Q(e);
}
//#endregion
//#region src/react/streams.ts
function $(e) {
	let { streams: t } = W();
	return J((e, n) => t.list({
		...e,
		dataset_id: n.datasetId,
		destination_id: n.destinationId
	}), {
		datasetId: e?.datasetId,
		destinationId: e?.destinationId
	}, e);
}
function Re(e) {
	let { streams: t } = W();
	return q(n(() => t.get(e), [t, e]));
}
function ze() {
	let { streams: e } = W(), t = K(n((t) => e.create(t), [e]));
	return {
		...t,
		createStream: t.run,
		stream: t.data,
		isCreating: t.pending
	};
}
function Be() {
	let { streams: e } = W(), t = K(n((t, n) => e.update(t, n), [e]));
	return {
		...t,
		updateStream: t.run,
		stream: t.data,
		isUpdating: t.pending
	};
}
function Ve() {
	let { streams: e } = W(), t = K(n((t) => e.testNew(t), [e]));
	return {
		...t,
		testNewStream: t.run,
		result: t.data,
		isTesting: t.pending
	};
}
function He() {
	let { streams: e } = W(), t = K(n((t, n) => e.testExisting(t, n), [e]));
	return {
		...t,
		testExistingStream: t.run,
		result: t.data,
		isTesting: t.pending
	};
}
function Ue() {
	let { streams: e } = W(), t = K(n((t) => e.testExpression(t), [e]));
	return {
		...t,
		testExpression: t.run,
		result: t.data,
		isTesting: t.pending
	};
}
//#endregion
export { g as DATASET_FREQUENCY_MINUTES, _ as DEFAULT_API_VERSION, c as DEFAULT_FORM_ROOT_KEY, ne as DEFAULT_IMPORT_API_BASE_URL, re as DEFAULT_IMPORT_APP_ID, se as ImportProvider, v as UNKNOWN_IMPORT_API_ERROR_CODE, y as UNKNOWN_IMPORT_API_ERROR_STATUS_CODE, p as applyFormDefaultFields, f as coerceFormValue, I as createDatasetsApi, ae as createDefaultClient, L as createDestinationsApi, R as createExtractsApi, E as createHttpClient, ee as createImportApiRoutes, z as createLoadsApi, F as createProviderScopedImportApiRoutes, V as createSourcesApi, H as createStreamsApi, N as defaultImportApiRoutes, u as getFormValue, x as isImportApiError, l as normalizeFormPath, m as prepareFormValues, d as setFormValue, S as toImportApiError, me as useCreateDataset, Ae as useCreateSource, ze as useCreateStream, de as useDataset, fe as useDatasetSchema, _e as useDestination, X as useDynamicForm, be as useExtract, ye as useExtractDebug, W as useImportContext, ue as useListDatasets, ge as useListDestinations, ve as useListExtracts, xe as useListLoads, Te as useListSources, $ as useListStreams, Se as useLoad, Ce as useLoadDebug, ke as usePreviewSourceRows, pe as useRandomSampleDataset, Ee as useSource, Ie as useSourceForm, Le as useSourceFormFields, Oe as useSourceSchema, De as useSourceTables, Re as useStream, Ne as useTestExistingSource, He as useTestExistingStream, Ue as useTestExpression, Me as useTestNewSource, Ve as useTestNewStream, he as useUpdateDataset, je as useUpdateSource, Be as useUpdateStream };

//# sourceMappingURL=index.js.map